module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe6f85e727a54500960eda169018bb52a.e6f85e72.png";